/**
 * Friendly date formatting in the user's locale.
 * e.g. 12 Jan 2023
 */
export function formatDateLocal(
  date: Date,
  options?: Intl.DateTimeFormatOptions,
  locale?: string | string[],
): string {
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat(locale, options).format(date);
}
